/* =====================================================================
 * Helpers
 * ===================================================================*/

export default {
  numberFix(number, toFixed = 1) {
    return Number.parseFloat(number).toFixed(toFixed);
  },

  isInViewport(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },

  getParentByClass(element, selector) {
    for ( ; element && element !== document; element = element.parentNode) {
      if (element.classList.contains(selector)) return element;
    }
    return null;
  },

  getParentByNodeName(element, nodeName) {
    for ( ; element && element !== document; element = element.parentNode) {
      if (element.nodeName === nodeName) return element;
    }
    return null;
  },

  triggerEvent(element, eventType) {
    if (element.fireEvent) {
      (element.fireEvent('on' + eventType));
      return;
    }
    const evObj = document.createEvent('Events');
    evObj.initEvent(eventType, true, false);
    element.dispatchEvent(evObj);
  },

  addNotice(parent, message) {
    let notice = parent.querySelector('.' + 'input-notice');
    if (notice) return;
    notice = document.createElement('p');
    notice.className = 'input-notice';
    notice.innerHTML = message;
    parent.appendChild(notice);
    parent.classList.add('input-error');
  },

  removeNotice(parent) {
    if (parent.classList.contains('input-error')) {
      parent.classList.remove('input-error');
      const notice = parent.querySelector('.' + 'input-notice');
      if (notice) parent.removeChild(notice);
    }
  },

  setCookie(cookieName, cookieValue, cookieExpire) {
    const date = new Date();
    date.setTime(date.getTime() + (cookieExpire * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
  },

  getCookie(cookieName) {
    const name = cookieName + '=';
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return '';
  }
};
